import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[dev-func-host]',
})
export class DevFuncDirective {
  constructor(public viewContainerRef: ViewContainerRef) {
  }
}